import { randJobTitle, randWord, randNumber } from '@ngneat/falso';

import { Reference } from '../base';

export class MockReference extends Reference {
   constructor() {
      super();

      this.party = randJobTitle();
      this.type = randWord().toUpperCase();
      this.data = Array.from(
         {
            length: randNumber({ min: 15, max: 35 }) // between 15 and 35 char
         }
      ).map( _ => randNumber({ max: 9 }) ).join( '' );
   }
}
